// Shared page state: the Leaflet map, once created.
export const ui = { map: null };
